import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Checkbox, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import pink from "@mui/material/colors/pink";

// Component imports
import { makeid, IsOrder } from "../../../helpers/helper_methods";
import ButtonCell from "../../common/button_cell";
import moment from "moment/moment";

// Font Awesome imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

// User context for getting the global user object
import UserContext from "../../../context/user_context";

/*
    RegistryTableBody Component

    Handles the logic for populating the body of the registry table
*/

export default function RegistryTableBody(props) {
  const {
    patientData,
    isSelected,
    isRowSelected,
    fullTable,
    setSelectedPatient,
    handleRowCheck,
    registry,
    registry_columns,
    cart,
    handleSetCart,
    location,
    patientView,
    setShowModal,
    highCriticality,
    physician,
    setSelected,
    setDocument,
  } = props;

  const currentUser = useContext(UserContext);

  // Methods to populate the tables cells with dynamic column structure

  function ButtonCellWrapper(rc, rowData, patient) {
    var resultObj = rowData;
    var displayLabel = null;

    if (rowData.test_results.length > 0) {
      rowData.test_results.map((tr) => {
        if (tr.test.code == rc.registry_test.test.code) {
          resultObj = tr;

          if (rc.registry_test.orderable) {
            displayLabel = (
              <>
                <Row className="justify-content-md-center">
                  <Col>
                    <span>{tr.test.code}</span>
                  </Col>
                </Row>
              </>
            );
          } else if (tr.last_value !== "") {
            displayLabel = (
              <>
                <Row className="justify-content-md-center">
                  <Col>
                    <span>{tr.last_value}</span>
                  </Col>
                </Row>
                {tr.last_date != null && rc.show_date !== false ? (
                  <Row>
                    <Col>
                      <small>{moment(tr.last_date).format("L")}</small>
                    </Col>
                  </Row>
                ) : null}
              </>
            );
          }
        }
      });
    }

    var selected = false;
    if (rowData.orderable_tests != null) {
      rowData.orderable_tests.map((ot) => {
        cart.map((ci) => {
          if (
            ci.orderable_test_id == ot.id &&
            ot.test.code == rc.registry_test.test.code
          ) {
            selected = true;
          }
        });
      });

      var orderable = false;
      var orderableTest = null;

      rowData.orderable_tests.map((ot) => {
        if (
          ot.test.code == rc.registry_test.test.code &&
          rc.registry_test.orderable
        ) {
          orderable = ot.currently_orderable;
          orderableTest = ot;
          displayLabel = ot.test.code;
        }
      });
    }

    return (
      <ButtonCell
        me={rc.registry_test.orderable ? rc.registry_test : resultObj}
        row={rowData}
        rc={rc}
        label={displayLabel}
        handleSetCart={handleSetCart}
        patient={patient}
        selected={selected}
        orderable={rc.registry_test.orderable && orderable}
        location={location}
        orderableTest={orderableTest}
        registry={registry}
        registryComparitor={{
          highCriticality: highCriticality != undefined,
          location: location.id,
          physician: physician.value,
        }}
        setSelected={setSelected}
        patientView={patientView}
        ro={resultObj}
      />
    );
  }

  function populateCell(rc, rowData, pdIndex, index) {
    var isName = rc.name.toLowerCase() == "name";

    if (
      rc.registry_test != null &&
      rc.registry_test.orderable &&
      patientView != undefined &&
      patientView
    ) {
      return null;
    } else if (rc.active) {
      var splitDisplayName = rc.data_field.split(".");

      if (splitDisplayName[0] == "status") {
        return <TableCell key={makeid(10)}>Initial</TableCell>;
      } else if (rc.registry_test != null && fullTable) {
        return (
          <TableCell key={makeid(15)}>
            {ButtonCellWrapper(rc, rowData.episode, rowData.patient)}
          </TableCell>
        );
      } else if (rc.registry_test == null) {
        if (splitDisplayName.length > 1) {
          let next = rowData;
          let document = rowData.episode.document;

          return splitDisplayName.map((dn, index) => {
            if (!(index == splitDisplayName.length - 1)) {
              next = next[dn];
            } else {
              if (isName && patientView != null && patientView) {
                return (
                  <Tooltip
                    key={makeid(15)}
                    title={`Double click for patient details`}
                  >
                    <TableCell
                      style={
                        isName && patientView != null && patientView
                          ? { cursor: `pointer` }
                          : {}
                      }
                      onDoubleClick={() => {
                        if (isName && patientView != null && patientView) {
                          setShowModal(rowData);
                        }
                      }}
                      key={makeid(15)}
                    >
                      {next[dn] == null || next[dn] == " " ? "N/A" : next[dn]}
                      <a
                        style={
                          document != null && document.url != "" && isName
                            ? {}
                            : { display: "none" }
                        }
                        onClick={() => setDocument(document)}
                        className={`clickableIcon`}
                      >
                        <FontAwesomeIcon
                          className={`fa-lg`}
                          icon={faRightFromBracket}
                        />
                      </a>
                    </TableCell>
                  </Tooltip>
                );
              } else {
                return (
                  <TableCell
                    style={
                      isName && patientView != null && patientView
                        ? { cursor: `pointer` }
                        : {}
                    }
                    onDoubleClick={() => {
                      if (isName && patientView != null && patientView) {
                        setShowModal(true);
                      }
                    }}
                    key={makeid(15)}
                  >
                    {next[dn] == null || next[dn] == " "
                      ? "N/A"
                      : `${next[dn]} `}

                    <a
                      style={
                        document != null && document.url != "" && isName
                          ? {}
                          : { display: "none" }
                      }
                      onClick={() => setDocument(document)}
                      className={`clickableIcon`}
                    >
                      <FontAwesomeIcon
                        className={`fa-lg`}
                        icon={faRightFromBracket}
                      />
                    </a>
                  </TableCell>
                );
              }
            }
          });
        } else {
          if (isName) {
            return (
              <Tooltip title={`Double click for patient details`}>
                <TableCell
                  onDoubleClick={() => {
                    if (isName) {
                      setShowModal(true);
                    }
                  }}
                  key={makeid(15)}
                >
                  {rowData[splitDisplayName]}
                </TableCell>
              </Tooltip>
            );
          } else {
            return (
              <TableCell
                onDoubleClick={() => {
                  if (isName) {
                    setShowModal(true);
                  }
                }}
                key={makeid(15)}
              >
                {rowData[splitDisplayName]}
              </TableCell>
            );
          }
        }
      }
    }
  }

  return (
    <TableBody>
      {patientData.length > 0 ? (
        patientData.map((rowData, pdIndex) => {
          const isItemSelected = isSelected(rowData);

          const rowSelected = isRowSelected(rowData);
          return (
            <TableRow
              style={!fullTable ? { cursor: `pointer` } : {}}
              hover={!fullTable}
              key={makeid(15)}
              selected={rowSelected}
              onClick={(e) => {
                if (!fullTable) {
                  setSelectedPatient(rowData);
                }
              }}
            >
              <TableCell
                key={makeid(15)}
                padding={`checkbox`}
                style={
                  patientView == true || !IsOrder(currentUser)
                    ? { display: "none" }
                    : {}
                }
                sx={{
                  "&.Mui-checked": {
                    color: pink[`A400`],
                  },
                }}
              >
                <FormControlLabel
                  aria-label={`Check Row ${pdIndex + 1}`}
                  control={
                    <Checkbox
                      checked={isItemSelected}
                      onChange={(e) =>
                        handleRowCheck(e, rowData.episode.id, rowData)
                      }
                      sx={{
                        "&.Mui-checked": {
                          color: pink[`A400`],
                        },
                      }}
                    />
                  }
                />
              </TableCell>
              {registry_columns
                .sort((a, b) => {
                  return a.order - b.order;
                })
                .map((rc, index) => {
                  return populateCell(rc, rowData, pdIndex, index);
                })}
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell colSpan={12}>No Records Found</TableCell>
        </TableRow>
      )}
    </TableBody>
  );
}
